import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/usage/denied/usage.deniedPortfolio.query.gql"
import type {
  UsageLicenseDeniedPortfolioQuery,
  UsageLicenseDeniedPortfolioQueryVariables,
} from "@/v2-backoffice-client/usage/denied/__types__/usage.deniedPortfolio.query"

type Options = QueryHookOptions<
  UsageLicenseDeniedPortfolioQuery,
  UsageLicenseDeniedPortfolioQueryVariables
>

export function useUsageLicenseDeniedPortfolioQuery(options?: Options) {
  return useQuery<
    UsageLicenseDeniedPortfolioQuery,
    UsageLicenseDeniedPortfolioQueryVariables
  >(query, options)
}
